








































































































































import Vue from "vue";
import InfoCard from "@/components/SpaceOverview/InfoCard.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import InfoLine from "@/components/SpaceOverview/InfoLine.vue";
import { format } from "@/utils/memoryFormat";

export default Vue.extend({
  name: "Overview",
  components: {
    InfoCard,
    InfoLine
  },
  computed: {
    ...mapState("Overview", [
      "basicLoading",
      "basic",
      "resourceLoading",
      "resource",
      "memoryLoading",
      "memory",
      "cpuLoading",
      "cpu",
      "containerLoading",
      "container",
      "podLoading",
      "pod",
      "maxCpu",
      "usedCpu",
      "maxMemory",
      "usedMemory",
      "resourceMemoryLoading",
      "resourceCpuLoading"
    ])
  },
  data() {
    return {
      usedMemoryValue: "",
      maxMemoryValue: ""
    };
  },
  watch: {
    usedMemory: {
      immediate: true,
      handler(usedMemory) {
        this.usedMemoryValue = format(usedMemory);
      }
    },
    maxMemory: {
      immediate: true,
      handler(maxMemory) {
        this.maxMemoryValue = format(maxMemory);
      }
    }
  },
  mounted() {
    this.getBasic();
    this.getCpuMax();
    this.getMemaryMax();
    // this.getResource();
    // this.getMemaryUse();
    // this.getCpuUse();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("Overview", [
      "getBasic",
      "getResource",
      "getMemaryUse",
      "getCpuUse",
      "getContainer",
      "getPod",
      "getMemaryMax",
      "getCpuMax"
    ]),
    ...mapMutations("Overview", { clear: "CLEAR" }),
    getColor(v: string) {
      if (!v) return "green";
      const value = parseInt(v);
      if (value > 75) {
        return "red";
      } else if (value > 50) {
        return "yellow";
      } else {
        return "red";
      }
    }
  }
});
